export default {
    login_verification_text: "Hi {user}, we sent a verification code to {email}. Please enter the code to sign in",
    code_resent: "Verificaiton code re-sent successfully",
}
